<template>
    <div class="h-full w-full flex flex-col">
        <EventForm mode="create" :entities="entities" @created="$emit('created')" @close="$emit('close')" />
    </div>
</template>

<script>
import EventForm from "./form.vue";
export default {
    name: "event-create",
    emits: ["created", "close"],
    props: ["entities"],
    components: { EventForm, },
}
</script>